module.exports = __webpack_public_path__ + "img/s1_t1_24.26a3df9a.jpeg";